<template>
  <div class="vx-row">
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <!-- <vx-card> -->
    <div v-else class="w-full">
      <div
        slot="no-body"
        class="tabs-container inventory_tabSec"
        id="view-customer-tab"
      >
        <vs-tabs
          alignment="fixed"
          v-model="activeTab"
          class="tab-action-btn-fill-conatiner"
        >
          <vs-tab :label="$t('setup.label.NumberZone')">
            <vx-card>
              <vs-table
                :max-items="paginationItems[1]"
                pagination
                :data="numberZone"
                :description="false"
                @selected="handleSelected1"
                search
                :description-items="paginationItems"
                description-title="Registries"
                description-connector="of"
                description-body="Pages"
              >
                <template slot="header">
                  <div class="list-heading">
                    {{ $t("setup.label.NumberZone") }}
                  </div>
                  <div class="mr-2 mb-1 order-1">
                    <vs-button
                      icon-pack="feather"
                      icon="icon-plus"
                      @click="$router.push({ name: 'Create Number Zone' })"
                      size="small"
                      >{{ $t("setup.label.CreateNumberZone") }}</vs-button
                    >
                  </div>
                </template>
                <template slot="thead">
                  <vs-th>{{ $t("setup.label.SourceNumberPrefix") }}</vs-th>
                  <vs-th>{{ $t("setup.label.DestinationNumberPrefix") }}</vs-th>
                  <vs-th>{{ $t("setup.label.ImpactCategory") }}</vs-th>
                  <vs-th>{{ $t("setup.label.Rank") }}</vs-th>
                  <!-- <vs-th>{{ $t("Event Record Type") }}</vs-th> -->

                  <vs-th class="tHeadCenter">{{
                    $t("setup.label.Action")
                  }}</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr
                    :key="index"
                    :data="numberZone"
                    v-for="(numberZone, index) in data"
                  >
                    <vs-td :data="numberZone.sourceNumberPrefix">{{
                      numberZone.sourceNumberPrefix
                    }}</vs-td>
                    <vs-td :data="numberZone.destinationNumberPrefix">{{
                      numberZone.destinationNumberPrefix
                    }}</vs-td>
                    <vs-td :data="numberZone.impactCategory">{{
                      numberZone.impactCategory
                    }}</vs-td>
                    <vs-td :data="numberZone.rank">{{ numberZone.rank }}</vs-td>
                    <!-- <vs-td :data="broadcasters.eventrecordtype">{{
                    broadcasters.eventrecordtype
                  }}</vs-td> -->

                    <vs-td class="whitespace-no-wrap">
                      <div class="container_img">
                        <feather-icon
                          icon="EditIcon"
                          :title="$t('setup.label.Edit')"
                          svgClasses="w-5 h-5 text-warning stroke-current cursor orange_icon"
                          @click.stop="EditNumZone(numberZone.id)"
                          class="icon_row"
                        />
                        <feather-icon
                          icon="TrashIcon"
                          :title="$t('setup.label.Delete')"
                          svgClasses="w-5 h-5 text-danger stroke-current cursor"
                          @click.stop="
                            deleteNumberZonePopup = true;
                            deleatId = numberZone.id;
                          "
                          class="icon_row"
                        />
                      </div>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
              <div class="centerx">
                <vs-popup
                  classContent="popup-example"
                  :title="$t('setup.label.DeleteNumberZone')"
                  :active.sync="deleteNumberZonePopup"
                  class="popup-close mid-popup"
                >
                  <div class="vx-row md:w-full lg:w-full sm:w-full mb-6">
                    <div class="vx-col sm:w-full w-full">
                      <div class="vx-col sm:w-full w-full">
                        {{ $t("setup.label.AreYouSure") }}
                      </div>
                    </div>
                  </div>
                  <div class="vx-row">
                    <span class="ml-4 mr-1">
                      <vs-button
                        type="border"
                        @click="deleteNumberZonePopup = false"
                        >{{ $t("setup.label.Cancel") }}</vs-button
                      >
                    </span>
                    <span class="ml-1 mr-2">
                      <vs-button
                        @click="deleteNumberTeam(deleatId)"
                        color="warning"
                        >{{ $t("setup.label.Ok") }}</vs-button
                      >
                    </span>
                  </div>
                </vs-popup>
              </div>
            </vx-card>
          </vs-tab>
          <vs-tab :label="$t('setup.label.APNZone')">
            <vx-card>
              <vs-table
                :max-items="paginationItems[1]"
                pagination
                :data="apnZone"
                :description="false"
                @selected="handleSelected"
                search
                :description-items="paginationItems"
                description-title="Registries"
                description-connector="of"
                description-body="Pages"
              >
                <template slot="header">
                  <div class="list-heading">
                    {{ $t("setup.label.APNZone") }}
                  </div>
                  <div class="mr-2 mb-1 order-1">
                    <vs-button
                      icon-pack="feather"
                      icon="icon-plus"
                      @click="$router.push({ name: 'Create APN Zone' })"
                      size="small"
                      >{{ $t("setup.label.CreateAPNZone") }}</vs-button
                    >
                  </div>
                </template>
                <template slot="thead">
                  <vs-th>{{ $t("setup.label.APN") }}</vs-th>
                  <vs-th>{{ $t("setup.label.ImpactCategory") }}</vs-th>
                  <vs-th>{{ $t("setup.label.Rank") }}</vs-th>
                  <vs-th class="tHeadCenter">{{
                    $t("setup.label.Action")
                  }}</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr
                    :key="index"
                    :data="apnZone"
                    v-for="(apnZone, index) in data"
                  >
                    <vs-td :data="apnZone.apn">{{ apnZone.apn }}</vs-td>
                    <vs-td :data="apnZone.impactCategory">{{
                      apnZone.impactCategory
                    }}</vs-td>

                    <vs-td :data="apnZone.rank">{{ apnZone.rank }}</vs-td>
                    <vs-td class="whitespace-no-wrap">
                      <div class="container_img">
                        <feather-icon
                          icon="EditIcon"
                          :title="$t('setup.label.Edit')"
                          svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                          @click.stop="editZoneApn(apnZone.id)"
                          class="icon_row"
                        />
                        <feather-icon
                          icon="TrashIcon"
                          :title="$t('setup.label.Delete')"
                          svgClasses="w-5 h-5 text-danger stroke-current cursor"
                          @click.stop="
                            editJobsUomPopup = true;
                            deleatId = apnZone.id;
                          "
                          class="icon_row"
                        />
                      </div>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
              <div class="centerx">
                <vs-popup
                  classContent="popup-example"
                  :title="$t('setup.label.DeleteAPNZone')"
                  :active.sync="editJobsUomPopup"
                  class="popup-close mid-popup"
                >
                  <div class="vx-row md:w-full lg:w-full sm:w-full mb-6">
                    <div class="vx-col sm:w-full w-full">
                      <div class="vx-col sm:w-full w-full">
                        {{ $t("setup.label.AreYouSure") }}
                      </div>
                    </div>
                  </div>
                  <div class="vx-row">
                    <span class="ml-4 mr-1">
                      <vs-button
                        type="border"
                        @click="editJobsUomPopup = false"
                        >{{ $t("setup.label.Cancel") }}</vs-button
                      >
                    </span>
                    <span class="ml-1 mr-2">
                      <vs-button
                        @click="deleteApnTeam(deleatId)"
                        color="warning"
                        >{{ $t("setup.label.Ok") }}</vs-button
                      >
                    </span>
                  </div>
                </vs-popup>
              </div>
            </vx-card>
          </vs-tab>
          <vs-tab :label="$t('setup.label.OperatorZone')">
            <vx-card>
              <vs-table
                :max-items="paginationItems[1]"
                pagination
                :data="operatorZone"
                :description="false"
                @selected="handleSelected2"
                search
                :description-items="paginationItems"
                description-title="Registries"
                description-connector="of"
                description-body="Pages"
              >
                <template slot="header">
                  <div class="list-heading">
                    {{ $t("setup.label.OperatorZone") }}
                  </div>
                  <div class="mr-2 mb-1 order-1">
                    <vs-button
                      icon-pack="feather"
                      icon="icon-plus"
                      @click="$router.push({ name: 'Create Operator Zone' })"
                      size="small"
                      >{{ $t("setup.label.CreateOperatorZone") }}</vs-button
                    >
                  </div>
                </template>
                <template slot="thead">
                  <vs-th>{{ $t("setup.label.SourceOperatorCode") }}</vs-th>
                  <vs-th>{{ $t("setup.label.DestinationOperatorCode") }}</vs-th>
                  <vs-th>{{ $t("setup.label.ImpactCategory") }}</vs-th>
                  <vs-th>{{ $t("setup.label.Rank") }}</vs-th>
                  <vs-th class="tHeadCenter">{{
                    $t("setup.label.Action")
                  }}</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr
                    :key="index"
                    :data="operatorZone"
                    v-for="(operatorZone, index) in data"
                  >
                    <vs-td :data="operatorZone.sourceOperatorCode">{{
                      operatorZone.sourceOperatorCode
                    }}</vs-td>
                    <vs-td :data="operatorZone.destinationOperatorCode">{{
                      operatorZone.destinationOperatorCode
                    }}</vs-td>
                    <vs-td :data="operatorZone.impactCategory">{{
                      operatorZone.impactCategory
                    }}</vs-td>
                    <vs-td :data="operatorZone.rank">{{
                      operatorZone.rank
                    }}</vs-td>
                    <vs-td class="whitespace-no-wrap">
                      <div class="container_img">
                        <feather-icon
                          icon="EditIcon"
                          :title="$t('setup.label.Edit')"
                          svgClasses="w-5 h-5  stroke-current cursor orange_icon"
                          @click.stop="editOperZone(operatorZone.id)"
                          class="icon_row"
                        />
                        <feather-icon
                          icon="TrashIcon"
                          :title="$t('setup.label.Delete')"
                          svgClasses="w-5 h-5 text-danger stroke-current cursor"
                          @click.stop="
                            editJobsRumPopup = true;
                            deleatId = operatorZone.id;
                          "
                          class="icon_row"
                        />
                      </div>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
              <div class="centerx">
                <vs-popup
                  classContent="popup-example"
                  :title="$t('setup.label.DeleteOperatorZone')"
                  :active.sync="editJobsRumPopup"
                  class="popup-close mid-popup"
                >
                  <div class="vx-row md:w-full lg:w-full sm:w-full mb-6">
                    <div class="vx-col sm:w-full w-full">
                      <div class="vx-col sm:w-full w-full">
                        {{ $t("setup.label.AreYouSure") }}
                      </div>
                    </div>
                  </div>
                  <div class="vx-row">
                    <span class="ml-4 mr-1">
                      <vs-button
                        type="border"
                        @click="editJobsRumPopup = false"
                        >{{ $t("setup.label.Cancel") }}</vs-button
                      >
                    </span>
                    <span class="ml-1 mr-2">
                      <vs-button
                        @click="deleteOperatorTeam(deleatId)"
                        color="warning"
                        >{{ $t("setup.label.Ok") }}</vs-button
                      >
                    </span>
                  </div>
                </vs-popup>
              </div>
            </vx-card>
          </vs-tab>
          <vs-tab :label="$t('setup.label.ICZone')">
            <vx-card>
              <vs-table
                :max-items="paginationItems[1]"
                pagination
                :data="icZone"
                :description="false"
                @selected="handleSelected3"
                search
                :description-items="paginationItems"
                description-title="Registries"
                description-connector="of"
                description-body="Pages"
              >
                <template slot="header">
                  <div class="list-heading">
                    {{ $t("setup.label.ICZone") }}
                  </div>
                  <div class="mr-2 mb-1 order-1">
                    <vs-button
                      icon-pack="feather"
                      icon="icon-plus"
                      @click="$router.push('/setup/zone-setup/create_ic_zone')"
                      size="small"
                      >{{ $t("setup.label.CreateICZone") }}</vs-button
                    >
                  </div>
                </template>
                <template slot="thead">
                  <vs-th>{{ $t("setup.label.IncomingTrunkid") }}</vs-th>
                  <vs-th>{{ $t("setup.label.OutcomingTrunkid") }}</vs-th>
                  <vs-th>{{ $t("setup.label.ImpactCategory") }}</vs-th>
                  <vs-th>{{ $t("setup.label.Rank") }}</vs-th>
                  <vs-th class="tHeadCenter">{{
                    $t("setup.label.Action")
                  }}</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr
                    :key="index"
                    :data="icZone"
                    v-for="(icZone, index) in data"
                  >
                    <vs-td :data="icZone.incomingTrunkId">{{
                      icZone.incomingTrunkId
                    }}</vs-td>
                    <vs-td :data="icZone.outgoingTrunkId">{{
                      icZone.outgoingTrunkId
                    }}</vs-td>
                    <vs-td :data="icZone.impactCategory">{{
                      icZone.impactCategory
                    }}</vs-td>
                    <vs-td :data="icZone.rank">{{ icZone.rank }}</vs-td>

                    <vs-td class="whitespace-no-wrap">
                      <div class="container_img">
                        <feather-icon
                          icon="EditIcon"
                          :title="$t('setup.label.Edit')"
                          svgClasses="w-5 h-5 text-warning stroke-current cursor orange_icon"
                          @click.stop="editIc(icZone.id)"
                          class="icon_row"
                        />
                        <feather-icon
                          icon="TrashIcon"
                          :title="$t('setup.label.Delete')"
                          svgClasses="w-5 h-5 text-danger stroke-current cursor"
                          @click.stop="
                            deleteIcPopup = true;
                            deleatId = icZone.id;
                          "
                          class="icon_row"
                        />
                      </div>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
              <div class="centerx">
                <vs-popup
                  :title="$t('setup.label.DeleteIcZone')"
                  :active.sync="deleteIcPopup"
                  class="popup-close mid-popup"
                >
                  <div class="vx-row md:w-full lg:w-full sm:w-full mb-6">
                    <div class="vx-col sm:w-full w-full">
                      <div class="vx-col sm:w-full w-full">
                        {{ $t("setup.label.AreYouSure") }}
                      </div>
                    </div>
                  </div>
                  <div class="vx-row">
                    <span class="ml-4 mr-1">
                      <vs-button type="border" @click="deleteIcPopup = false">{{
                        $t("setup.label.Cancel")
                      }}</vs-button>
                    </span>
                    <span class="ml-1 mr-2">
                      <vs-button
                        @click="deleteIcTeam(deleatId)"
                        color="warning"
                        >{{ $t("setup.label.Ok") }}</vs-button
                      >
                    </span>
                  </div>
                </vs-popup>
              </div>
            </vx-card>
          </vs-tab>
        </vs-tabs>
      </div>
    </div>
    <!-- </vx-card> -->
  </div>
</template>
<script>
import { mapState } from "vuex";
import { AtomSpinner } from "epic-spinners";

export default {
  data() {
    return {
      loading: false,
      paginationItems: [5, 10, 15],
      deletePopup: false,
      delId: 0,
      deleatId: 0,
      editJobsUomPopup: false,
      editJobsRumPopup: false,
      deleteIcPopup: false,
      deleteNumberZonePopup: false,
      // provisioningRumList: [],
      // hardwareUomList: [],
      provisioningActionsList: [],
      networkElementList: [],
    };
  },
  components: { AtomSpinner },
  computed: {
    ...mapState({
      apnZone: (state) => state.zoneSetup.GetApnZone,
      operatorZone: (state) => state.zoneSetup.GetOperatorZone,
      icZone: (state) => state.zoneSetup.GetIcZone,
      numberZone: (state) => state.zoneSetup.GetNumberZone,
      products: (state) => state.zoneSetup.GetUsageRatePlan,
    }),
  },
  methods: {
    async getNumberZoneData() {
      this.loading = true;
      try {
        this.$store.dispatch("zoneSetup/setNumberZoneList", {});
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.loading = false;
    },
    async deleteNumberTeam(id) {
      try {
        await this.$store.dispatch("zoneSetup/deleteNumZone", id);
        this.getNumberZoneData();
        this.deleteNumberZonePopup = false;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getApnZoneData() {
      this.loading = true;
      try {
        this.$store.dispatch("zoneSetup/setApnZoneList", {});
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.loading = false;
    },
    async deleteApnTeam(id) {
      try {
        await this.$store.dispatch("zoneSetup/deleteApnZone", id);
        this.getApnZoneData();
        this.editJobsUomPopup = false;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getOperatorZoneData() {
      this.loading = true;
      try {
        this.$store.dispatch("zoneSetup/setOperatorZoneList", {});
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.loading = false;
    },
    async deleteOperatorTeam(id) {
      try {
        await this.$store.dispatch("zoneSetup/deleteOperatorZone", id);
        this.getOperatorZoneData();
        this.editJobsRumPopup = false;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getIcZoneData() {
      this.loading = true;
      try {
        this.$store.dispatch("zoneSetup/setIcZoneList", {});
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.loading = false;
    },
    async deleteIcTeam(id) {
      try {
        await this.$store.dispatch("zoneSetup/deleteIcZone", id);
        this.getIcZoneData();
        this.deleteIcPopup = false;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    EditNumZone(id) {
      this.$router.push({ name: "Edit Number Zone", params: { id: id } });
    },
    editZoneApn(id) {
      this.$router.push({ name: "Edit APN Zone", params: { id: id } });
    },
    handleSelected(apnZone) {
      this.$router.push({
        name: "View APN Zone",
        params: { id: apnZone.id },
      });
    },
    handleSelected1(numberZone) {
      this.$router.push({
        name: "View Number Zone",
        params: { id: numberZone.id },
      });
    },
    editOperZone(id) {
      this.$router.push({ name: "Edit Operator Zone", params: { id: id } });
    },
    handleSelected2(operatorZone) {
      this.$router.push({
        name: "View Operator Zone",
        params: { id: operatorZone.id },
      });
    },
    editIc(id) {
      this.$router.push({ name: "Edit IC Zone", params: { id: id } });
    },
    handleSelected3(icZone) {
      this.$router.push({
        name: "View IC Zone",
        params: { id: icZone.id },
      });
    },

    editCreatesystem(id) {
      this.$router.push(`/editCreateSystem/${id}`);
    },
  },
  mounted() {
    this.getNumberZoneData();
    this.getApnZoneData();
    this.getOperatorZoneData();
    this.getIcZoneData();
  },
};
</script>
<style scoped>
::v-deep .vs-tabs--ul {
  width: 90%;
}
.inventory_tabSec >>> .con-vs-tabs .vs-tabs--ul {
  box-shadow: none !important;
}
</style>
